import * as React from 'react';
import Modal from '@mui/material/Modal';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';
import FormDropDown from '../components/form/FormDropDown';
import FormDatePicker from '../components/form/FormDatePicker';
import FormConditionCheck from '../components/form/FormConditionCheck';
import FormMultiSelectChipsFilter from '../components/form/FormMultiSelectChipsFilter';

import { useQuery } from '@tanstack/react-query'
import {useAuth} from '../context/AuthProvider';
import {useMessage} from '../context/MessageProvider';

import {categoryList, typeList, statusList} from '../models/categories';
import { listAnimals } from '../models/animals';
import { name as animalName } from '../utils/animal';
import { newChange, saveChange } from '../models/changes';

import { useConnectivity } from '../context/ConnectivityProvider';

import { name as speciesName } from "../utils/species";

import Header from './Header';
import { useRevalidator } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "100%",
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 12,
  borderRadius: "4px",
  p: 2,
};

export default function ChangeModal({open,dispatch,defaults}) {
    const handleClose = () => dispatch(false);
    const revalidator = useRevalidator();
    const {setSuccess } = useMessage();
    const {facilityId, user} = useAuth();
    const {isOnline} = useConnectivity();

    const {isLoading, isError, data, error} = useQuery({
        queryKey: ['changes'],
        queryFn: async() => {
            return {
                categories: await categoryList(),
                types: await typeList(),
                statuses: await statusList(),
                animals: await listAnimals(),
            };
        },
        networkMode: "offlineFirst",
    });

    const [working,setWorking] = React.useState(false);
    const defaultValues = {...newChange()};
    if (defaults.animal) {
        defaultValues.animals.push(defaults.animal.id);
    }
    const formProps = { defaultValues };
	const methods = useForm(formProps);

    const onSubmit = async(data) => {
        setWorking(true);
        console.log("change data", data);
        const results = await saveChange(data,facilityId,user.id,isOnline);
        console.log("save results: ", results);
        setSuccess("Change Saved");
        revalidator.revalidate();
        methods.reset();
        setWorking(false);
    }

    const onSubmitAndClose = async(data) => {
        await onSubmit(data);
        methods.reset();
        handleClose();
    }

    if (isError) throw error;

    const speciesFilter = (data?.animals || []).reduce((acc, cur) => {
        if (acc.includes(cur.species) === false) acc.push(cur.species);
        return acc;
    }, []).map((cur) => {
        return { value: cur, label: speciesName(cur) };
    });

    return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="changes-modal-title"
      aria-describedby="changes-modal-description"
    >
        <Container maxWidth="xs" sx={style}>
            {isLoading && <div>Loading</div>}
            {!isLoading && <>
                <Header label="Report Change" />
                <FormProvider {...methods}>
                    <Form>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={6}>
                                <FormDropDown name="category" label="Category" list={data.categories} required />
                            </Grid>

                            <Grid xs={12} sm={6}>
                                <FormDropDown name="change_type" label="Type" list={data.types} required />
                            </Grid>

                            <Grid xs={12} sm={12}>
                                <FormDropDown name="status" label="Status" list={data.statuses} required />
                            </Grid>

                            <FormConditionCheck name="status" value="single_event" >
                                <Grid xs={12} sm={12}>
                                    <FormDatePicker name="start" label="Start" required />
                                </Grid>
                            </FormConditionCheck>

                            <FormConditionCheck name="status" value="discrete_period" >
                                <Grid xs={6} sm={6}>
                                    <FormDatePicker name="start" label="Start" required />
                                </Grid>

                                <Grid xs={6} sm={6}>
                                    <FormDatePicker name="end" label="End" required />
                                </Grid>
                            </FormConditionCheck>

                            <FormConditionCheck name="status" value="ongoing" >
                                <Grid xs={12} sm={12}>
                                    <FormDatePicker name="start" label="Start" required />
                                </Grid>
                            </FormConditionCheck>

                            <Grid xs={12} sm={12}>
                                <FormTextField name="description" label="Describe the details of the change" multiline minRows="2" required />
                            </Grid>

                            <Grid xs={12} sm={12}>
                                <FormMultiSelectChipsFilter
                                    enableSelectAll
                                    name="animals"
                                    label="Animals Impacted"
                                    required
                                    list={data.animals.map((cur) => { return { label: animalName(cur), value: cur.id } })}
                                    enableTextFilter={true}
                                    enableSelectFilter={true}
                                    selectFilterList={speciesFilter}
                                />
                            </Grid>

                            <Grid xs={12}>
                                <FormButton onSubmit={methods.handleSubmit(onSubmitAndClose)} fullWidth working={working}>Submit and close</FormButton>
                            </Grid>
                            <Grid xs={12}>
                            <FormButton onSubmit={methods.handleSubmit(onSubmit)} fullWidth working={working}>
                                Submit and Reset Form
                            </FormButton>
                            </Grid>
                        </Grid>
                    </Form>
                </FormProvider>
            </>}


        </Container>

    </Modal>
  );

}
/*

                            <FormButton resetOnSubmit onSubmit={handleSaveAndReset} fullWidth>
      <Box sx={style}>
        <Typography id="changes-modal-title" variant="h6" component="h2">
          Text in a modal
        </Typography>
        <Typography id="changes-modal-description" sx={{ mt: 2 }}>
          Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
        </Typography>
      </Box>
      */
